import { render, staticRenderFns } from "./RdsNotifications.vue?vue&type=template&id=3a8cc0a0&scoped=true&"
import script from "./RdsNotifications.vue?vue&type=script&lang=js&"
export * from "./RdsNotifications.vue?vue&type=script&lang=js&"
import style0 from "./RdsNotifications.vue?vue&type=style&index=0&id=3a8cc0a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8cc0a0",
  null
  
)

export default component.exports